import React from "react";
import ReactDom from "react-dom";
import { Col } from "react-bootstrap";
import _ from "lodash";
import Spinner from "./spinner";

export default React.createClass({

  //@TODO set the column widths as default props that can be overridden using getDefaultProps()

  render: function(){

    let stat = this.props.stat;
    if (stat) stat = stat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    let data = "";
    if (_.isNull(stat)){
      data = <Spinner />;
    } else {
      data = <strong>{ stat }</strong>;
    }

    return(
        <div className="stat-flexbox">
          <div className="box">
              <div className="box-stat">
                {data}
              </div>
            <p>{ this.props.label }</p>
          </div>
        </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/stat-box.jsx